import { Tooltip } from "@mui/material";
import { Layers, X } from "lucide-react";
import { Trans } from "react-i18next";
import { useHistory } from "react-router-dom";
import type { DeckType } from "src/api/flashcardDecks";
import { IconButton } from "src/components/Default/LekUI/Button";
import SimpleProgressBar from "src/components/Default/LekUI/SimpleProgressBar";

import { DeckModeMenu } from "./DeckModeMenu";

export interface DeckProgress {
	current: number;
	total: number;
}

interface DeckInfoProps {
	deck: { name: string };
	deckId: number;
	progress: DeckProgress;
	currentMode: DeckType;
}

export function DeckInfo({
	deck,
	deckId,
	progress,
	currentMode,
}: DeckInfoProps) {
	const history = useHistory();
	const percent = progress.total
		? Math.round((progress.current / progress.total) * 100)
		: 0;

	const closeDeck = () => {
		history.push("/");
	};

	return (
		<div className="flashcard--deck--info">
			<div className="flashcard--deck--info--top">
				<Layers className="icon-normal text-primary flashcard--deck--info--icon" />
				<Tooltip title={deck.name}>
					<h2
						className="flashcard--deck--info--name text-ellipsis-1"
						data-test-id="flashcard-deck-name"
					>
						{deck.name}
					</h2>
				</Tooltip>
				<DeckModeMenu
					deckId={deckId}
					currentMode={currentMode}
					className="flashcard--deck--info--menu"
				/>
				<IconButton
					onClick={closeDeck}
					className="flashcard--deck--info--close"
					data-test-id="flashcard-close-button"
				>
					<X className="icon-normal" />
				</IconButton>
			</div>
			<div
				className="flashcard--deck--info--progress"
				data-test-id="flashcard-progress"
			>
				<span className="size-14 text-grey ws-nowrap">
					<Trans
						i18nKey="decks.progress"
						defaults="Fiszka <0>{{current}}</0> z {{total}}"
						values={progress}
						components={[<strong key="0" className="text-black" />]}
					/>
				</span>
				<SimpleProgressBar
					color="primary"
					variant="determinate"
					value={percent}
					className="flex-1"
				/>
				<span className="size-14 ws-nowrap">{percent}%</span>
			</div>
		</div>
	);
}
